import { Buffer } from "buffer";
import { pendingImportsKey } from "components/Layout/Sidebar/components/CreateNew/CreateNew";
import "containers/AdvancedSearch/AdvancedSearch.scss";
import "containers/ExecutionFilter/ExecutionFilter.scss";
import { actions as resourcesActions } from "containers/Resources/Resources.reducer";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { logSubPageKey } from "utils/RouterManager/constants";
import { parseSearchParams } from "utils/RouterManager/searchParams";
import { actions as dataStoreAction } from "utils/DataStore/DataStore.reducer";

// Stable empty-array reference so the selector below doesn't allocate a new array
// (and re-render every consumer) on every dispatched action.
const EMPTY_PENDING_IMPORTS: unknown[] = [];

/**
 * Custom hook to handle pending imports of files.
 *
 * This hook is responsible for processing files that are pending import.
 * It checks if the current path includes the log list path fragment and
 * if there are any pending imports. If both conditions are met, it processes
 */
export const usePendingImports = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const pendingImports = useSelector(
        (state: any) => state?.dataStore?.[pendingImportsKey] ?? EMPTY_PENDING_IMPORTS
    );

    useEffect(() => {
        // Logs moved from a path fragment (/…/log-list) to a query flag (?logs); detect it
        // via the search params, not the pathname, or imports silently never run.
        const isOnLogsPage = logSubPageKey in parseSearchParams(history.location.search);
        if (isOnLogsPage && pendingImports.length > 0) {
            const promises = pendingImports.map(
                (fileInfo) =>
                    new Promise((resolve, reject) => {
                        dispatch({
                            type: resourcesActions.START_IMPORT_RESOURCE,
                            promise: { resolve, reject },
                            fileData: Buffer.from(fileInfo.content, "binary"),
                            fileName: fileInfo.name,
                        });
                    })
            );

            Promise.allSettled(promises).then(() => {
                dispatch({
                    type: dataStoreAction.CLEAN_DATA,
                    key: pendingImportsKey,
                });
            });
        }
    }, [dispatch, history.location.search, pendingImports]);
};
